import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { EditComponent } from './edit/edit.component';

import { AuthGuard } from '../auth.guard';

export const routing: Routes = [
  {
    path: 'calendar',
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      { path: '', component: EditComponent },
      { path: 'edit', component: EditComponent },
    ]
  }
];
